export default __webpack_public_path__ + "static/image11-64e067ec3504a03ec9317fd51c7e8cab.jpg";